import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AmpButton from "../../common/AmpButton/AmpButton";
import AmpDropdown from "../../common/AmpDropdown/AmpDropdown";
import AmpFormError from "../../common/AmpFormError/AmpFormError";
import AmpInput from "../../common/AmpInput/AmpInput";
import SmallHeading from "../../common/AmpSmallHeading/AppSmallHeading";
import { FormRegTabs } from "../RegistrationTypes";

export interface SecurityProps extends FormRegTabs {
    setSecFormValid: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function Security(props: SecurityProps) {

    const { t } = useTranslation('login');

    // Security Question/Answer State
    const [securityQuestion, setSecurityQuestion] = useState("");
    const [customUserQuestion, setCustomQuestion] = useState("");
    const [securityAnswer, setSecurityAnswer] = useState("");
    const [confSecurityAnswer, setConfSecurityAnswer] = useState("");

    const handleChangeSecurityQ = (value: string) => {
        setSecurityQuestion(value);
    }

    const customQid = "custom-q";
    const answerId = "security-answer";
    const confAnswerId = "conf-security-answer";

    // Security Question/Answer error messaging
    const showCustomQuestion = securityQuestion === "5";
    const customQuestionError = (customUserQuestion === "" && securityQuestion === "5") || (securityQuestion === "" || securityQuestion === "-1");
    const securityAnswerError = securityAnswer.length < 4 && securityAnswer !== "";
    const confSecurityAnswerError = confSecurityAnswer !== "" && confSecurityAnswer !== securityAnswer;

    const securityTabFormValid =
        !customQuestionError &&
        !securityAnswerError &&
        !confSecurityAnswerError &&
        confSecurityAnswer !== "" &&
        securityAnswer !== "";
    
    const submitSecQuestion = () => {
        if(securityTabFormValid) {
            const payload = {...props.payload}
            //     "security_question": showCustomQuestion ? customUserQuestion : securityQuestion,
            //     "is_custom": showCustomQuestion,
            //     "security_answer": securityAnswer,
            payload.security_question = showCustomQuestion ? customUserQuestion : securityQuestion;
            payload.is_custom = showCustomQuestion;
            payload.security_answer = securityAnswer;
            props.setPayload(payload);
            props.setActiveTab(4);
            props.setSecFormValid(true);
        }  
    }

    return (
        <>
            <div className="dark-blue-background">
                {t('3-sec-top-text') as string}
            </div>
            <div className="login-container-mid">
                <AmpDropdown
                    onChange={(event) => {
                        handleChangeSecurityQ((event.target as HTMLOptionElement).value);
                    }}
                    options={[
                        {
                            value: "-1",
                            text: t('3-select-a-q')
                        },
                        {
                            value: "1",
                            text: t('3-what-childhood-nick')
                        },
                        {
                            value: "2",
                            text: t('3-what-childhood-friend')
                        },
                        {
                            value: "3",
                            text: t('3-city-job-q')
                        },
                        {
                            value: "4",
                            text: t('3-what-spouse')
                        },
                        {
                            value: "5",
                            text: t('3-create-custom-q')
                        }
                    ]}
                />
                {
                    showCustomQuestion ?
                        (
                            <>
                                <SmallHeading for={customQid}>
                                    {t('3-custom-q') as string}
                                </SmallHeading>
                                <AmpInput noTimer={true} isError={customQuestionError} isValid={!customQuestionError} onInput={(value) => setCustomQuestion(value)} type="text" id={customQid} name="custom-question" />

                            </>)
                        :
                        <></>
                }
                <AmpFormError error={customQuestionError} errorMessage={t('3-no-q')} />
                <SmallHeading for={answerId}>
                    {t('3-enter-response') as string}
                </SmallHeading>
                <AmpInput noTimer={true} isError={securityAnswerError} isValid={!securityAnswerError} onInput={(value) => setSecurityAnswer(value)} type="text" id={answerId} name="security-answer" disabled={customQuestionError} />
                <AmpFormError error={securityAnswerError} errorMessage={t('3-no-answer')} />

                <SmallHeading for={confAnswerId}>
                    {t('3-conf-response') as string}
                </SmallHeading>
                <AmpInput noTimer={true} isError={confSecurityAnswerError} isValid={!confSecurityAnswerError && confSecurityAnswer === securityAnswer} onInput={(value) => setConfSecurityAnswer(value)} type="text" id={confAnswerId} name="conf-security-answer" disabled={customQuestionError} />
                <AmpFormError error={confSecurityAnswerError} errorMessage={t('3-no-conf')} />

            </div>
            <div className="login-container-footer">
                <Link rel="noreferrer noopener" target="_blank" className="amp-anchor" to="/auth/contact-us">{t("need-help") as string}</Link>
                <div>
                    <AmpButton type="cancel" onClick={() => props.triggerCancel(true)} text={t("cancel")} />
                    <AmpButton type="cancel" onClick={() => props.setActiveTab(2)} text={t("back")} />
                    <AmpButton type="submit" onClick={() => submitSecQuestion()} text={t("next")} disabled={!securityTabFormValid} />
                </div>
            </div>
        </>
    );
}  